export const filterNulls = <T>(list: Array<T | null>): T[] => list.filter((v) => v !== null) as T[]

export const filterUndefined = <T>(list: Array<T | Error | undefined>): T[] => list.filter((v) => v !== undefined) as T[]

export const filterError = <T>(list: Array<T | Error>): T[] => list.filter((v) => !(v instanceof Error)) as T[]
